// ============================================================================
//  edgeApi — browser client for the erp-api Edge Function (Option B).
//
//  All calls go to a single function endpoint; the signed session token
//  (obtained from login) is attached to every authenticated request. The
//  anon key is sent only to authorize *invoking* the function — the real
//  authorization is the session token, verified server-side.
// ============================================================================

import { SUPABASE_URL, SUPABASE_ANON_KEY } from './config';
import { getTenantId } from '../tenant';

const FN_URL = `${SUPABASE_URL}/functions/v1/erp-api`;

let sessionToken = null;
export function setEdgeToken(token) { sessionToken = token || null; }
export function getEdgeToken() { return sessionToken; }
export function clearEdgeToken() { sessionToken = null; }

async function call(action, body = {}) {
  const res = await fetch(FN_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      apikey: SUPABASE_ANON_KEY,
      Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
    },
    body: JSON.stringify({ action, token: sessionToken, ...body }),
  });
  let data = {};
  try { data = await res.json(); } catch { /* ignore */ }
  if (!res.ok) {
    const err = new Error(data.error || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return data;
}

export const edgeApi = {
  login: (username, password) => call('login', { tenant: getTenantId(), username, password }),
  logout: () => call('logout'),
  loadApp: () => call('loadApp'),
  saveApp: (rows) => call('saveApp', { rows }),
  loadAuth: () => call('loadAuth'),
  saveAuth: (users) => call('saveAuth', { users }),
  validateSession: () => call('validateSession'),
  loadLog: () => call('loadLog'),
  appendLog: (entry) => call('appendLog', { entry }),
};
